// src/services/MobileBridge.js
import { doc, updateDoc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db, auth } from '../firebase';

/**
 * Registers the physical hardware of the phone to the user's 3D profile.
 * This creates a permanent link between the UID and the physical device GPU/ID.
 */
export const registerHardwareLock = async (deviceId) => {
  const user = auth.currentUser;
  if (!user) return;

  try {
    const deviceRef = doc(db, 'hardware_locks', deviceId);
    
    // 1. Store the hardware info in a central registry
    await setDoc(deviceRef, {
      ownerUid: user.uid,
      deviceModel: window.navigator.userAgent, 
      platform: window.navigator.platform,
      lastUsed: serverTimestamp(),
      biometricEnabled: true,
      status: 'active'
    }, { merge: true });

    // 2. Tether the User Document to this specific Hardware ID
    await updateDoc(doc(db, 'users', user.uid), {
      trustedDeviceId: deviceId,
      mobileAccess: true,
      lastMobileLogin: serverTimestamp()
    });

    console.log("Hardware Lock Secured: Device tethered to profile.");
  } catch (error) {
    console.error("Error registering hardware lock:", error);
  }
};

/**
 * Validates if the current mobile device matches the tethered ID in the user's profile.
 */
export const verifyHardwareMatch = async (deviceId) => {
  const user = auth.currentUser;
  if (!user) return false;

  try {
    const snap = await getDoc(doc(db, 'users', user.uid));
    if (!snap.exists()) return false;

    const userData = snap.data();
    
    // If no device is tethered yet, this is the first login; allow it and tether now.
    if (!userData.trustedDeviceId) {
      await registerHardwareLock(deviceId);
      return true;
    }

    // Return true only if the hardware signatures match exactly
    return userData.trustedDeviceId === deviceId;
  } catch (error) {
    console.error("Hardware verification failed:", error);
    return false;
  }
};

/**
 * Auto-initialization check to be called on the Dashboard
 */
export const checkAndRegisterDevice = async (deviceId) => {
  const user = auth.currentUser;
  if (!user) return;

  const snap = await getDoc(doc(db, 'users', user.uid));
  if (snap.exists() && !snap.data().trustedDeviceId) {
    await registerHardwareLock(deviceId);
  }
};
      
